export default "__VITE_ASSET__CYe7tx7k__"